import NormalList from './NormalList';

export default NormalList;